export const COMMON_CLASS_NAMES = {
  ACTIVE: 'is-active',
  AVAILABLE: 'is-available',
  INIT: 'is-init',
  IGNORE: 'js-ignore',
};